<template>
    <div class="join flex-nowrap" data-cy="product-listing-pagination-links">
        <a
            :href="currentPage === 1 ? '#' : linkToPage(1)"
            class="btn btn-sm join-item"
            aria-label="First page"
        >
            <MiscIcon name="chevrons-left" class="h-5 w-5" />
        </a>
        <a
            :href="currentPage - 1 < 1 ? '#' : linkToPage(currentPage - 1)"
            class="btn btn-sm join-item"
            aria-label="Previous page"
        >
            <MiscIcon name="chevron-left" class="h-5 w-5" />
        </a>
        <button type="button" class="btn btn-sm btn-ghost normal-case join-item no-animation" v-text="`Page ${currentPage} of ${maxPage}`" />
        <a
            :href="currentPage + 1 > maxPage ? '#' : linkToPage(currentPage + 1)"
            class="btn btn-sm join-item"
            aria-label="Next page"
        >
            <MiscIcon name="chevron-right" class="h-5 w-5" />
        </a>
        <a
            :href="currentPage + 1 > maxPage ? '#' : linkToPage(maxPage)"
            class="btn btn-sm join-item"
            aria-label="Last page"
        >
            <MiscIcon name="chevrons-right" class="h-5 w-5" />
        </a>
    </div>
</template>

<script setup lang="ts">

interface ProductListingPaginationProps {
    currentPage: number,
    limit: number,
    totalPages: number,
}

const props = withDefaults(defineProps<ProductListingPaginationProps>(), {})

const route = useRoute()

const maxPage = computed(() => {
    return Math.ceil(props.totalPages / props.limit)
})

function linkToPage (page: number): string {
    const params = new URLSearchParams(route.fullPath.replace(route.path, ''))
    params.set('p', page.toString())
    return route.path + '?' + params.toString()
}
</script>
